import React, { Component } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

const MONTHS = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

const STATUS = [
  { key: "due", label: "AMC Due", color: "#ef6c00", textColor: "#fff" },
  { key: "pending", label: "AMC Pending", color: "#1976d2", textColor: "#fff" },
  {
    key: "submitted",
    label: "Renewal Submitted",
    color: "#fbc02d",
    textColor: "#1a1a1a",
  },
  { key: "done", label: "Renewal Done", color: "#2e7d32", textColor: "#fff" },
  { key: "lost", label: "Renewal Lost", color: "#d32f2f", textColor: "#fff" },
];

const buildCalendarData = () => {
  const baseRows = [
    {
      branch: "BHAVNAGAR",
      pending: 120,
      submitted: 45,
      done: 30,
      lost: 10,
    },
    {
      branch: "RAJKOT",
      pending: 120,
      submitted: 45,
      done: 30,
      lost: 10,
    },
    {
      branch: "BARODA",
      pending: 120,
      submitted: 45,
      done: 30,
      lost: 10,
    },
    {
      branch: "SURAT",
      pending: 130,
      submitted: 45,
      done: 30,
      lost: 10,
    },
  ];

  return baseRows.map((row) => {
    const months = {};
    MONTHS.forEach((m) => {
      const due = row.pending + row.submitted + row.done + row.lost;
      months[m] = {
        due,
        pending: row.pending,
        submitted: row.submitted,
        done: row.done,
        lost: row.lost,
      };
    });

    return { branch: row.branch, months };
  });
};

class AMCCalendarView extends Component {
  state = {
    data: buildCalendarData(),
  };

  render() {
    const data = this.props.data?.length ? this.props.data : this.state.data;

    return (
      <Card sx={{ p: 2, borderRadius: 3, overflowX: "auto" }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/#/Dashboard">
              Dashboard
            </Link>
            <Link underline="hover" color="inherit" href="/#/AMCDashboard">
              AMC Dashboard
            </Link>
          <Typography sx={{ color: "text.primary" }}>Calendar View</Typography>
        </Breadcrumbs>

        <Grid container spacing={1} sx={{ borderBottom: "1px solid #e0e0e0" }}>
          <Grid item sx={{ width: 120 }} />
          {MONTHS.map((m) => (
            <Grid item key={m} sx={{ width: 90, textAlign: "center" }}>
              <Typography fontWeight={700}>{m}</Typography>
            </Grid>
          ))}
        </Grid>

        {data.map((row, i) => (
          <Box key={i} sx={{ mt: 2 }}>
            <Grid container spacing={1}>
              <Grid item sx={{ width: 120 }}>
                <Typography fontWeight={700}>{row.branch}</Typography>
              </Grid>

              {MONTHS.map((month) => (
                <Grid item key={month} sx={{ width: 90 }}>
                  {STATUS.map((s) => (
                    <Box
                      key={s.key}
                      sx={{
                        background: s.color,
                        color: s.textColor,
                        fontSize: 13,
                        fontWeight: 700,
                        textAlign: "center",
                        borderRadius: 0.5,
                        my: 0.3,
                        py: 0.4,
                        cursor: "pointer",
                        boxShadow: "inset 0 -1px 0 rgba(0,0,0,0.2)",
                      }}
                      onClick={() => console.log(row.branch, month, s.key)}
                    >
                      {row.months[month]?.[s.key]}
                    </Box>
                  ))}
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}

        <Box sx={{ display: "flex", gap: 2, mt: 3, flexWrap: "wrap" }}>
          {STATUS.map((s) => (
            <Box key={s.key} sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  background: s.color,
                  mr: 1,
                  borderRadius: 0.5,
                }}
              />
              <Typography variant="caption">{s.label}</Typography>
            </Box>
          ))}
        </Box>
      </Card>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCCalendarView {...props} navigate={navigate} />;
}

export default WithNavigate;
